export const product = {
	addToCart: {
		inStock: 'Currently In-Stock',
		quantity: 'Quantity',
		buy: 'Buy',
		add: 'Add',
		accountPurchaseRestrictionMessage: 'Your Account does not have permission to purchase this product. Please contact your ISR or DSM for assistance.',
		userPurchaseRestrictionMessage: 'Your G360 user policies restrict you from purchasing this product.',
	},
	productSummary: {
		id: 'Model',
		part: 'Part',
	},
	productList: {
		product: 'Product',
		priceMsrp: 'Price (MSRP)',
		priceMslp: 'Price (MSLP)',
		priceMixed: 'Price (MSRP/MSLP)',
		tooltipPriceMixed: 'MSRP (Manufacturer’s Suggested Retail Price) applies to models. MSLP (Manufacturer’s Suggested List Price) applies to service parts.',
		tooltipPriceMslp: 'MSLP (Manufacturer’s Suggested List Price) applies to service parts.',
		quantity: 'Quantity',
		tooltipLtlMessage: 'Indicates this item must ship via LTL truck; it cannot ship via UPS',
		tooltipFlammableMessage: 'Flammable item; must ship via ground',
		tooltipNoAirFreightMessage: 'This item cannot be shipped using any form of air freight. Those Shipping Options will be removed as eligible selections from Checkout.',
		noResults: 'No results were found for your search query',
		fileType: 'File Type',
		fileName: 'File Name',
		itemNumber: 'Item Number',
		language: 'Language',
	},
	productDetails: {
		id: 'Model',
		title: 'downloads:',
		link: 'Spec Sheet',
		viewAllDocument: 'View All Documents',
		atestationDataRestrictionMessage: 'This is a restricted product. Purchase of this product is dependent on signing the Acknowledgement to Destroy agreement. You will need the serial number of the generator containing the faulty engine before proceeding with checkout.',
		scratchAndDentWarrantyInfo: 'Scratch & Dent products may show minor cosmetic blemishes and are backed by the full original manufacturer warranty. Reconditioned products are covered by a limited warranty: 1 year for Home Standby Generators and Portable Generators, and 90 days for Power Washers. But remember, the availability of these closeout items is always changing, and they often sell out quickly.',
	},
	itemCounter: {
		infoMessage: {
			step: 'Must be ordered in increments of {{step}}.',
			min: 'The product has a minimum quantity of {{min}}.',
			max: 'The product has a maximum quantity of {{max}}.',
			maxBundleQty: 'The bundle has a maximum quantity of {{max}} to purchase'
		},
	},
	bundle: {
		addToCartSuccess: 'Bundle was added successfully',
		addToCartFailed: 'Unfortunately, it\'s not possible to add product to the cart at the moment. Please try again later or contact us {{phoneNumber}}. For Service Parts issues or inquiries, please call 1-800-883-7535.',
		title: 'Buy This Item In A Bundle'
	},
	addToWishList: {
		add: 'Add To Favorites',
		remove: 'Saved To Favorites',
		noFavorites: 'No Favorites Yet',
		addToFavoriteModal: {
			title: 'Add To Favorite',
			selectList: 'Select List',
			add: 'Add',
			save: 'Save',
			infoMessage: 'Your selection will be automatically saved',
			addedLabel: 'Added',
			removedLabel: 'Removed',
		},
		favoriteList: {
			title: 'Your Lists',
			addNewList: 'Add New List',
			newListTitle: 'New List',
			listName: 'List Name',
			enterListName: 'Enter List Name',
			removeAllProductsFromList: 'Remove All Products from the List',
			editListName: 'Edit List Name',
			deleteList: 'Delete List',
			deleteListConfirmationText: 'Are you sure you want to delete the “{{listName}}” list?',
			deleteListInfoText: 'Deleting a list will delete all products contained in that list',
			removeAllItemsFromListConfirmationText: 'Do you want to remove all products from the "{{listName}}" list?',
			delete: 'Delete',
			remove: 'Remove',
			addAllToCartBtn: 'Add All to Cart',
			addAllToCartConfirmationText: 'Are you sure you want to add all items from the "{{listName}}" list to cart?',
			favoritesAddedToCart: `{{productsAmount}} favorite products have been added to the cart`,
		}
	},
	TabPanelContainer: {
		tabs: {
			WarrantyApplicableProductsComponent: 'Product Current Warranty Coverage',
			ApplicableProductsComponent: 'Applicable Products',
			ProductNotesTabComponent: 'Note',
			ManualsListComponent: 'Documents',
		},
	}
};